import React from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import NavBar from 'src/presentation/components/organisms/NavBar';
import Heading from 'src/presentation/components/atoms/Heading';
import UpdatePasswordForm from 'src/presentation/components/organisms/forms/UpdatePasswordForm';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Translations from 'src/core/utils/Translations';

function UpdatePasswordScreen() {
	return (
		<View style={styles.root}>
			<NavBar
				backBtn={true}
				bgcolor={Colors.primary}
				centerTitle={true}
				color={Colors.black}
				editBtn={false}
				title={Translations.titleChangePassword}
			/>
			<ScrollView keyboardShouldPersistTaps="always" style={styles.scroll}>
				<View style={styles.contentContainer}>
					<Heading text={Translations.titleChangePassword} />
					<Text style={styles.description}>{Translations.textChangePasswordDescription}</Text>
				</View>
				<UpdatePasswordForm />
			</ScrollView>
		</View>
	);
}

export default UpdatePasswordScreen;

const styles = StyleSheet.create({
	root: {
		flex: 1,
	},
	scroll: {
		backgroundColor: Colors.white,
	},
	contentContainer: {
		paddingLeft: Dimens.padding20,
		paddingRight: Dimens.padding20,
		paddingTop: Dimens.padding20,
	},
	description: {
		marginTop: Dimens.margin8,
		fontSize: Dimens.fontSize14,
		fontFamily: Fonts.montserratRegular,
		color: Colors.greyTextDark,
	},
});
